import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=45cb9fae&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=45cb9fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb9fae",
  null
  
)

component.options.__file = "partner.vue"
export default component.exports